import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LANGUAGES } from './language.constants';



const DEFAULT_TITLE = $localize`:@@global.title:Cebreo Medical`;

@Injectable({
  providedIn: 'root'
})
export class LanguageHelper {
  readonly languages$: Observable<string[]> = of(LANGUAGES);

  private _titleKey$: BehaviorSubject<string> = new BehaviorSubject<string>(DEFAULT_TITLE);
  readonly titleKey$: Observable<string> = this._titleKey$.asObservable();

  constructor(private titleService: Title, private router: Router) {
    this.updateTitle();

    this.titleKey$.pipe(
      map(t => {
        if (typeof t === 'string') {
          return t;
        } else if (typeof t === 'object') {
          const values = Object.values(t).filter(v => typeof v === 'string');
          if (values.length > 0) {
            return values[0] as string;
          }
        }
        return DEFAULT_TITLE;
      }),
      catchError(() => of(DEFAULT_TITLE)),
    ).subscribe(title => {
      this.titleService.setTitle(title);
    });
  }

  /**
   * Update the window title using params in the following
   * order:
   * 1. titleKey parameter
   * 2. $state.$current.data.pageTitle (current state page title)
   * 3. 'global.title'
   */
  updateTitle() {
    const pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);

    this._titleKey$.next(`${pageTitle}${pageTitle ? ' - ' : ''}${DEFAULT_TITLE}`);
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : '';

    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    return title;
  }
}
